module.exports = require("commonmark");


//////////////////
// WEBPACK FOOTER
// external "commonmark"
// module id = 589
// module chunks = 0